module.exports = __webpack_public_path__ + "static/media/yellow-chest.a4cea605.png";